type SortDirection = 'asc' | 'desc';

export function sortWithAlphabetTiebreaker<T extends { name: string }>(
    data: T[],
    sortBy: string,
    sortDir: SortDirection
): T[] {
    let direction = 1;
    if (sortDir === 'desc') direction = -1;

    const groupOf = (value: string) => {
        if (!value) return 2;
        if (value.toLowerCase() === 'unknown') return 1;
        return 0;
    };

    return [...data].sort((rowA, rowB) => {
        const valueA = (rowA as any)[sortBy] ?? '';
        const valueB = (rowB as any)[sortBy] ?? '';

        if (typeof valueA === 'string' && typeof valueB === 'string') {
            if (groupOf(valueA) !== groupOf(valueB)) return (groupOf(valueA) - groupOf(valueB)) * direction;
            if (valueA !== valueB) return valueA.localeCompare(valueB) * direction;
        } else {
            if (valueA !== valueB) {
                let order = 1;
                if (valueA < valueB) order = -1;
                return order * direction;
            }
        }

        return rowA.name.localeCompare(rowB.name);
    });
}
